<template>
  <div id="app">
    <layoutHead />
    <main class="main-container">
      <div class="main-content container mx-auto">
        <router-view v-if="isRouterAlive" />
      </div>
    </main>
  </div>
</template>
<script>
import layoutHead from '@/components/layout/header.vue';
import initialWallet from '@/components/basic/initialWallet.vue';
import transactionPool from '@/components/basic/transactionPool.vue';
export default {
  mixins: [initialWallet,transactionPool],
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isRouterAlive: true,
    };
  },
  components: {
    layoutHead,
  },
  methods: {
    reload() {
      console.log('aaa');
      this.isRouterAlive = false;
      this.$nextTick(() => (this.isRouterAlive = true));
    },
  },
};
</script>

<style lang="less" scoped>
#app {
  background-color: #323c41;
  .main-container {
    margin-top: 88px;
    .main-content {
      min-height: 800px;
    }
  }
}
</style>
